import React from 'react';
import PurchaseList from './PurchaseList';
import './Purchases.css';

export default function Projects({invoices, selectedInvoice, setSelectedInvoice}) {
  return <div className="purchases-container"><PurchaseList invoices={invoices} selectedInvoice={selectedInvoice} setSelectedInvoice={setSelectedInvoice}></PurchaseList></div>;
}